import className from 'classnames';
import { ReactSVG } from 'react-svg';
import Tooltip from 'react-tooltip-lite';
import { useTranslation } from 'utils/i18n';
import { formatPrice } from 'utils/price';
import { formatStartAndEndTimes } from 'utils/time';
import {
  DESKTOP_TOOLTIP_DISTANCE,
  MOBILE_TOOLTIP_DISTANCE,
} from '../../constants/breakpoints';
import useIsMobile from '../../hooks/useIsMobile';

interface TimeSlotProps {
  // Always present when endTime is: the two arrive as a pair off a slot.
  startTime?: string;
  endTime?: string;
  cost?: number;
  hasHelp?: boolean;
  helpText?: string;
  hasError?: boolean;
  errorLabel?: string;
}

const TimeSlot = ({
  startTime,
  endTime,
  cost,
  hasHelp = false,
  helpText,
  hasError = false,
  errorLabel = '',
}: TimeSlotProps) => {
  const { t } = useTranslation('common');
  const classes = className({
    // eslint-disable-next-line camelcase
    space__item: true,
    // eslint-disable-next-line camelcase
    space__timeslot: true,
    'space__timeslot--error': hasError,
  });

  const isMobileView = useIsMobile();

  const timeSlot = endTime
    ? formatStartAndEndTimes(startTime!, endTime, 'HH:mm')
    : t('quick_book.space.please_select_a_timeslot');

  return (
    <li>
      <div className={classes} data-testid="spaceListItem">
        <span className="space__slot">
          {timeSlot}
          {hasHelp && (
            <div data-testid="spaceToolTip" data-cy="spaceToolTip">
              <Tooltip
                content={helpText || t('quick_book.space.time_slot_help_text')}
                className="space__tooltip"
                distance={
                  isMobileView
                    ? MOBILE_TOOLTIP_DISTANCE
                    : DESKTOP_TOOLTIP_DISTANCE
                }
              >
                <ReactSVG
                  src="images/icons/question-mark.svg"
                  width={17}
                  height={17}
                />
              </Tooltip>
            </div>
          )}
          {hasError && (
            <span
              className="space__slot_error"
              data-testid="spaceListItemErrorLabel"
            >
              {' '}
              {!!errorLabel && ` (${errorLabel})`}
            </span>
          )}
        </span>

        <span className="space__price" data-testid="spacePrice">
          {formatPrice(cost)}
        </span>
      </div>
    </li>
  );
};

export default TimeSlot;
